import styled from 'styled-components';

import { Icon } from '@creditornot/alchemy-react';
import * as icons from '@creditornot/alchemy-react/icons';
import { color } from '@creditornot/cb-ingredients/design-tokens';

import { Stack } from './Stack';
import { Typography as T } from './Typography/Typography';
import { useFormatMessage } from '../../hooks/useFormatMessage';

const Root = styled(Stack)`
  color: ${color.textSubdued};
  padding: 32px;
  text-align: center;
`;

export const InvalidSearchQuery = () => {
  const f = useFormatMessage();
  return (
    <Root gap="regularXlarge" alignItems="center">
      <Icon source={icons.magnifyingGlass} size="medium" fill={color.textSubdued} />
      <T.subheadline>{f('common.min_search_query_length')}</T.subheadline>
    </Root>
  );
};
